import { createCommand } from '@atlassian/rovo-content-bridge-api';

/**
 * Properties for the rovo inline input box send message command.
 *
 * @extends CommandProperties
 */

/**
 * A command sent by the rovo inline input box client to send a message to rovo chat.
 *
 * @summary {@link CommandProperties.senderId} is requesting {@link CommandProperties.receiverId} to send a message to the input prompt box.
 */
export var InlineInputBoxSendMessageCommand = createCommand('inline-input-box-send-message-command');